import { render, staticRenderFns } from "./SortFAQs.vue?vue&type=template&id=0ed52a08&scoped=true&"
import script from "./SortFAQs.vue?vue&type=script&lang=js&"
export * from "./SortFAQs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed52a08",
  null
  
)

export default component.exports